import axios from "axios";
import {
	ForgotPassword,
	Login,
	ResetPassword,
	Session,
	RefreshSession,
	ChangePassword,
	Logout,
} from "../apiClient/endpoints";
import Axios from "../apiClient/instance/Axios";

/**
 * @route Session
 */
export const SessionService = () => {
  return Axios.get(Session);
};

/**
 * @route RefreshSession
 */
export const RefreshSessionService = () => {
  let headers = {};
  if (localStorage.getItem("jwt_refresh")) {
    headers["Authorization"] = `jwt ${localStorage.getItem("jwt_refresh")}`;
  }
  axios.defaults.baseURL = window.location.hostname.split(".")[1] == "clevai" ?
		"https://staging.sparkbackend.cerebry.co/api/v3/admin/competitions" :
		"https://staging.sparkbackend.cerebry.co/api/admin/competitions";
  axios.defaults.headers = headers;
  return axios.post(RefreshSession, { skipAuthRefresh: true });
};

/**
 * @route Login
 */
export const LoginService = (values) => {
  return Axios.post(Login, values);
};

/**
 * @route Logout
 */
export const LogoutService = () => {
  return Axios.post(Logout);
};

/**
 * @route Change Password
 */
export const ChangePasswordService = (values) => {
  return Axios.post(ChangePassword, values);
};

/**
 * @route Forgot Password
 */
export const ForgotPasswordService = (values) => {
  return Axios.post(ForgotPassword, values);
};

/**
 * @route  Reset Password
 */
export const ResetPasswordService = (values) => {
  return Axios.post(ResetPassword, values);
};
